module.exports = __webpack_public_path__ + "application/templates/default/partials/toolbar.template.html";